import { Gap, Heading, Panel, theme } from '@salecycle/ui-component-library';
import { ClientLevel } from 'core/types';
import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router';
import { useHistory } from 'react-router-dom';
import { useImportConsentContext } from '../context/ImportConsentContext';
import { FileManagementRoute } from '../routes';
import { ClientSelect } from 'components/experimental/ClientSelect';

export function ClientSelectionArea() {
  const { t } = useTranslation('fileManagement');
  const { clientId, clientLevel, setClientLevel, setClientId, setFileData } = useImportConsentContext();
  const { replace } = useHistory();

  const onClientChange = (clientId: string, clientLevel: ClientLevel): void => {
    setFileData([]);
    setClientId(clientId);
    replace(generatePath(FileManagementRoute.CLIENT_IMPORT_ANALYSIS, { clientId, clientLevel }));
  };

  return (
    <>
      <Gap top={50} />
      <Panel variation="clean" padding={0}>
        <Heading variation="h2" color={theme.vars.color.grey4}>
          {t('analysis.clientSelectionArea.heading')}
        </Heading>
        <Gap top={10} />
        <ClientSelect
          groupsEnabled={false}
          level={clientLevel}
          siteId={clientLevel === ClientLevel.SITE ? clientId : null}
          brandId={clientLevel === ClientLevel.BRAND ? clientId : null}
          onLevelChanged={level => {
            setClientLevel(level);
            setClientId(null);
            setFileData([]);
            replace(FileManagementRoute.IMPORT_ANALYSIS);
          }}
          onSiteChanged={clientId => {
            onClientChange(clientId, ClientLevel.SITE);
          }}
          onBrandChanged={clientId => {
            onClientChange(clientId, ClientLevel.BRAND);
          }}
        />
      </Panel>
    </>
  );
}
